import 'regenerator-runtime/runtime'
import {
  SurveyInstanceDataServicePromiseClient,
  GetAttemptQuestionsRequest,
  setRequest,
} from '@utils/index'

type Params = Partial<GetAttemptQuestionsRequest.AsObject>

const {
  REACT_APP_QUERY_HOST = 'https://staging.pandolink.com',
  REACT_APP_QUERY_PORT = '443',
} = process.env

export const getAttemptQuestions = async (
  params: Params,
  accessToken: string
) => {
  const service = new SurveyInstanceDataServicePromiseClient(
    `${REACT_APP_QUERY_HOST}:${REACT_APP_QUERY_PORT}`
  )

  GetAttemptQuestionsRequest
  const request = setRequest(new GetAttemptQuestionsRequest(), params)

  const result = await service.getAttemptQuestions(request, {
    authorization: `Bearer ${accessToken}`,
  })

  return result
}
